import Image from 'global/Image';
import { useMemo, useState } from 'react';
import ModalImageSlider from 'global/ImageSlider/Modal';
import { AttachmentImageContainer, ImageItemContainer, CloseWrapper } from './styled';
import { ImageType } from '../types';

interface ImagesProps {
  images: ImageType[];
  onSetImages: (images: ImageType[]) => void;
}

const Images = ({
  images,
  onSetImages,
}: ImagesProps) => {
  const [showModalImages, setShowModalImages] = useState<boolean>(false);
  const [active, setActive] = useState<number>(0);

  const transformedImages = useMemo(() => images.map((item) => item.preview), [images]);

  const handleRemoveFile = (index) => {
    const imageList = [...images];
    imageList.splice(index, 1);
    onSetImages(imageList);
  };

  const onClickImage = (i) => {
    setActive(i);
    setShowModalImages(!showModalImages);
  };

  return (
    <AttachmentImageContainer>
      {images.map((image, i) => (
        <ImageItemContainer>
          <CloseWrapper onClick={handleRemoveFile} draggable="false">
            <Image src="/icon/notes/notes-remove-image.svg" />
          </CloseWrapper>
          <Image
            src={image.preview}
            alt="preview"
            height="180"
            onClick={() => onClickImage(i)}
          />
        </ImageItemContainer>
      ))}
      <ModalImageSlider
        images={transformedImages}
        visible={showModalImages}
        onClose={() => setShowModalImages(false)}
        active={active}
        setActive={setActive}
      />
    </AttachmentImageContainer>

  );
};

export default Images;
